export class LienPriorityApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getUsedLienPriorities({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/used-lien-priorities`);
  }
}
